module.exports = __webpack_public_path__ + "img/image-style-10.64ff1a1f.svg";